import type { ReactNode } from 'react';

type IconComponent = React.ComponentType<{ className?: string }>;

interface IconWrapperProps {
  icon: IconComponent;
  className?: string;
  children?: ReactNode;
}

export const IconWrapper = ({ icon: Icon, className = '', children }: IconWrapperProps) => (
  <span className={className}>
    <Icon />
    {children}
  </span>
);
